import Input from 'components/common/form/input/Input';
import { Form, Formik } from 'formik';
import { Form as ReactForm } from 'react-bootstrap';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { RecruiterProfileFormValue, Props } from './recruiterProfile.type';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';
import { useUpdateRecruiterProfileMutation } from 'service/authQuery/authQuery';
import { useNavigate } from 'react-router-dom';
import Select from 'components/common/form/select/Select';
import { employeeOptions } from 'components/modules/auth/RecruiterSignUpForm/form/company/config';

const validationSchema = Yup.object().shape({
  recruiterName: Yup.string().required('Recruiter name is required'),
  recruiterDesignation: Yup.string().required(
    'Recruiter designation is required'
  ),
  contactEmail: Yup.string()
    .email('Invalid email format')
    .required('Contact email is required'),
  contactPhoneNumber: Yup.string()
    .required('Contact phone number is required')
    .matches(
      /^\+?[1-9]\d{1,14}$/,
      'Phone number must include a country code and be valid'
    ),
  username: Yup.string().required('Institution name is required'),
  address: Yup.string().required('Address is required'),
  numberOfEmployees: Yup.string().required('Number Of Employees is required')
});

function RecruiterProfile({ innerRef }: Props) {
  const data = useSelector((state: RootState) => state.user.user);
  const [updateRecruiter] = useUpdateRecruiterProfileMutation();

  const navigate = useNavigate();

  const handleSubmit = async (values: RecruiterProfileFormValue) => {
    try {
      await updateRecruiter(values);
      navigate(-1);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="mb-5">
      <Formik
        innerRef={innerRef}
        initialValues={{
          username: data.username ?? '',
          address:
            typeof data.info.address === 'string' ? data.info.address : '',
          recruiterName: data.info.recruiterName ?? '',
          recruiterDesignation: data.info.recruiterDesignation ?? '',
          contactEmail: data.info.contactEmail ?? '',
          contactPhoneNumber: data.info.contactPhoneNumber ?? '',
          numberOfEmployees: data.info.numberOfEmployees ?? ''
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          <Row className="g-5">
            <Col xs={12} xl={3}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="username">Company Name</FormLabel>
                <Input name="username" id="username" />
              </FormGroup>
            </Col>
            <Col xs={12} xl={3}>
              <FormGroup className="text-start">
                <FormLabel>Email Address</FormLabel>
                <ReactForm.Control value={data.email} disabled />
              </FormGroup>
            </Col>
            <Col xs={12} xl={6}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="address">Address</FormLabel>
                <Input name="address" id="address" />
              </FormGroup>
            </Col>
            <Col xs={12} xl={4}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="recruiterName">Recruiter Name</FormLabel>
                <Input name="recruiterName" id="recruiterName" />
              </FormGroup>
            </Col>
            <Col xs={12} xl={4}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="recruiterDesignation">
                  Recruiter Designation
                </FormLabel>
                <Input name="recruiterDesignation" id="recruiterDesignation" />
              </FormGroup>
            </Col>
            <Col xs={12} xl={4}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="contactEmail">Contact Email</FormLabel>
                <Input
                  name="contactEmail"
                  id="contactEmail"
                  type="email"
                  placeholder="name@example.com"
                />
              </FormGroup>
            </Col>
            <Col xs={12} xl={4}>
              <FormGroup className="mb-3 text-start">
                <FormLabel htmlFor="contactPhoneNumber">
                  Contact Phone Number
                </FormLabel>
                <Input name="contactPhoneNumber" id="contactPhoneNumber" />
              </FormGroup>
            </Col>
            <Col xs={12} xl={4}>
              <FormGroup className="mb-3 text-start">
                <FormLabel htmlFor="numberOfEmployees">
                  Number of Employees
                </FormLabel>
                <Select
                  name="numberOfEmployees"
                  id="numberOfEmployees"
                  options={employeeOptions}
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </Formik>
    </div>
  );
}

export default RecruiterProfile;
